import BotonAyudaManuales from "../../../Components/BotonAyudaManuales";
import { message, PageHeader, Popconfirm, Tooltip, Tag } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { TableItemDinamico, ButtonItem, SegmentedItem, MensajeError } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import { CheckCircleOutlined, CopyOutlined, EditOutlined, StopOutlined } from "@ant-design/icons";
import DuplicarPesupuestoPU from "./DuplicarPesupuestoPU/DuplicarPesupuestoPU";

moment.locale("es");

class PresupuestosPU extends Component {
  tableRef = null;
  state = {
    todasPresupuestosPU: [],
    loading: false,
    valor: 1,
    totalRecords: 0,
    modalDuplicar: false,
    modalDuplicarId: null
  };
  consultarPresupuestosPU(params) {
    this.setState({ loading: true });
    axios
      .post(
        "presupuestosPU/selectTodosPresupuestos",
        { empresaId: this.props.empresaId, ...params },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({
            todasPresupuestosPU: res.data.data,
            totalRecords: res.data.totalRecords || 0,
          });
        } else {
          this.setState({ todasPresupuestosPU: [] });
          MensajeError({ message: 'No se pudieron obtener los datos' })
        }
      });
  }
  refrescarPresupuestosPU() {
    if (this.tableRef) {
      this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
  }
  deshabilitarPresupuesto(value) {
    axios
      .post(
        "presupuestosPU/deshabilitarPresupuesto",
        { presupuestoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Presupuesto deshabilitado");
        } else {
          MensajeError({ message: "Sucedio un error y no se pudo deshabilitar" });
        }
        this.refrescarPresupuestosPU();
      });
  }
  habilitarPresupuesto(value) {
    axios
      .post(
        "presupuestosPU/habilitarPresupuesto",
        { presupuestoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Presupuesto habilitado");
        } else {
          MensajeError({ message: "Sucedio un error y no se pudo habilitar" });
        }
        this.refrescarPresupuestosPU();
      });
  }

  presupuestoPU(id) {
    if (id) {
      this.props.history.push("/panel/presupuestoPU", { id });
    } else {
      this.props.history.push("/panel/presupuestoPU");
    }
  }

  duplicarPresupuesto(id) {
    this.setState({ modalDuplicar: true, modalDuplicarId: id })
  }

  cerrarDuplicarPresupuestoPU() {
    this.setState({ modalDuplicar: false, modalDuplicarId: null })
    this.refrescarPresupuestosPU()
  }

  render() {
    const columns = [
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        sorter: true,
        buscar: "nombre",
        width: "20%",
      },
      {
        title: "Fecha Inicio",
        dataIndex: "fechaInicio",
        key: "fechaInicio",
        sorter: true,
        render: (value) => moment(value).locale("es").format("ll"),
        wdith: "20%",
        ellipsis: true,
        align: "center",
      },
      {
        title: "Fecha Final",
        dataIndex: "fechaFinal",
        key: "fechaFinal",
        sorter: true,
        render: (value) => moment(value).locale("es").format("ll"),
        wdith: "20%",
        ellipsis: true,
        align: "center",
      },
      {
        title: "Versión",
        dataIndex: "versionNumero",
        key: "versionNumero",
        width: "8%",
        align: "center",
        render: (versionNumero) => <Tag color="blue">{`v${versionNumero || 1}`}</Tag>,
      },
      {
        title: "Autorización",
        dataIndex: "autorizado",
        key: "autorizado",
        width: "12%",
        align: "center",
        render: (autorizado, record) => (
          record.superado
            ? <Tag color="default">Superado</Tag>
            : autorizado
              ? <Tag color="green">Autorizado</Tag>
              : <Tag color="orange">Borrador</Tag>
        ),
      },
      {
        title: "Accion",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: "15%",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value, record) => {
          let buttons = [];

          if (this.props.permisoEditarPresupuestoPU) {
            buttons.push(
              <Tooltip title="Editar Presupuesto" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`editar-${record._id}`}
                  type="default"
                  size="small"
                  cyan
                  icon={<EditOutlined />}
                  onClick={() => this.presupuestoPU(record._id)}
                >
                </ButtonItem>
              </Tooltip>
            );
          }

          if (this.props.permisoHabilitarPresupuestoPU && record.estado === 1) {
            buttons.push(
              <Popconfirm
                key={`deshabilitar-${record._id}`}
                title="Seguro que quieres deshabilitar este presupuesto"
                onConfirm={() => this.deshabilitarPresupuesto(record._id)}
                okText="Si"
                cancelText="No"
              >
                <Tooltip title="Deshabilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    type="default"
                    size="small"
                    lima
                    icon={<CheckCircleOutlined />}
                  >
                  </ButtonItem>
                </Tooltip>
              </Popconfirm>
            );
          } else if (this.props.permisoHabilitarPresupuestoPU) {
            buttons.push(
              <Popconfirm
                key={`habilitar-${record._id}`}
                title="Seguro que quieres habilitar este presupuesto"
                onConfirm={() => this.habilitarPresupuesto(record._id)}
                okText="Si"
                cancelText="No"
              >
                <Tooltip title="Habilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    type="default"
                    size="small"
                    rojo
                    icon={<StopOutlined />}
                  >
                  </ButtonItem>
                </Tooltip>
              </Popconfirm>
            );
          }

          if (this.props.permisoAgregarPresupuestoPU) {
            buttons.push(
              <Tooltip key={`duplicar-${record._id}`} title="Duplicar Presupuesto" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  type="default"
                  size="small"
                  blanco
                  icon={<CopyOutlined />}
                  onClick={() => this.duplicarPresupuesto(record._id)}
                >
                </ButtonItem>
              </Tooltip>
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];

    let buttons = []

    buttons.push(
      <>
        {window.innerWidth > 1000 &&
          <SegmentedItem
            options={[{ label: 'Activo', value: 1 }, { label: 'Deshabilitado', value: 2 }, { label: 'Todos', value: 3 }, { label: 'Pendientes de autorización', value: 4 }]}
            onChange={(value) => {
              if (this.tableRef) {
                this.tableRef.updateExternalFilters({ valor: value });
              }
              this.setState({ valor: value })
            }}
            value={this.state.valor}
          />
        }
        {this.props.permisoAgregarPresupuestoPU &&
          <ButtonItem
            type="primary"
            key="presupuestoPU"
            onClick={() => this.presupuestoPU()}
            olivo
            className="botonAgregar"
          >
            Agregar Presupuesto
          </ButtonItem>}
      </>
    )


    return (
      <>
        <PageHeader
          title="Presupuestos"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={[...buttons, <BotonAyudaManuales key="manuales" modulo="presupuestosPU" />]}
        />
        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={this.state.totalRecords}
          loading={this.state.loading}
          size="small"
          onFetchData={this.consultarPresupuestosPU.bind(this)}
          anadirValorFiltro={this.state.valor}
          dataSource={this.state.todasPresupuestosPU}
          columns={columns}
          filterStorageKey={"presupuestosPU" + this.props.empresaId}
          estadosLeyenda={[
            { color: 'rgb(223, 240, 216)', label: 'Confirmado', key: 'confirmado' },
          ]}
          rowClassName={(record) => record.confirmado ? "fila-confirmada" : ""}
          onRow={(record, rowIndex) => {
            return {
              onDoubleClick: (event) => {
                this.presupuestoPU(record._id)
              },
            };
          }}
          setValor={(valor) => this.setState({ valor })}
          valorDefault={1}
        />
        <DuplicarPesupuestoPU
          visible={this.state.modalDuplicar}
          id={this.state.modalDuplicarId}
          cerrarDuplicarPresupuestoPU={this.cerrarDuplicarPresupuestoPU.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoAgregarPresupuestoPU:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6750951f798d4e004368724d"
      )?.activado,
    permisoEditarPresupuestoPU:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6750955f798d4e004368724e"
      )?.activado,
    permisoHabilitarPresupuestoPU:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6aa43341a540d9e36418265e"
      )?.activado,

  };
};

export default connect(mapStateToProps)(PresupuestosPU);
